import { render, staticRenderFns } from "./_base-breadcrumbs.vue?vue&type=template&id=233ce6e3&scoped=true&"
import script from "./_base-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./_base-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./_base-breadcrumbs.vue?vue&type=style&index=0&id=233ce6e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ce6e3",
  null
  
)

export default component.exports